import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue, SelectGroup, SelectLabel } from "@/components/ui/select";
import { Switch } from "@/components/ui/switch";

export function Sel({ value, onChange, options, testid, disabled, placeholder, className = "", groups }) {
  return (
    <Select value={value === undefined || value === null ? undefined : String(value)} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger className={`h-10 bg-[hsl(220_12%_8%)] border-[hsl(220_10%_18%)] text-sm ${className}`} data-testid={testid}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="bg-popover border-border max-h-[360px]">
        {groups
          ? groups.map((g) => (
              <SelectGroup key={g.label}>
                <SelectLabel className="text-[10px] uppercase tracking-widest text-[hsl(43_50%_58%)]">{g.label}</SelectLabel>
                {g.options.map((o) => (
                  <SelectItem key={o.value} value={String(o.value)} data-testid={`${testid}-option-${o.value}`}>
                    {o.label}
                  </SelectItem>
                ))}
              </SelectGroup>
            ))
          : options.map((o) => (
              <SelectItem key={o.value} value={String(o.value)} data-testid={`${testid}-option-${o.value}`}>
                {o.label}
              </SelectItem>
            ))}
      </SelectContent>
    </Select>
  );
}

export function SwitchRow({ label, hint, checked, onChange, testid, disabled }) {
  return (
    <label className={`flex items-start justify-between gap-4 rounded-lg border border-border bg-[hsl(220_12%_8%)] px-3.5 py-2.5 ${disabled ? "opacity-70" : "cursor-pointer"}`}>
      <span>
        <span className="block text-sm">{label}</span>
        {hint && <span className="block text-[11px] text-muted-foreground mt-0.5">{hint}</span>}
      </span>
      <Switch checked={!!checked} onCheckedChange={onChange} disabled={disabled} data-testid={testid} className="mt-0.5" />
    </label>
  );
}
